import permissions from 'constants/permissions'

const STEPS = {
  MY_SUPPLIERS: {
    1: 'my-suppliers-step-1',
    2: 'my-suppliers-step-2',
    3: 'my-suppliers-step-3',
    4: 'my-suppliers-step-4',
  },
  SUGGESTIONS: {
    1: 'suggestions-step-1',
    2: 'suggestions-step-2',
  },
  QUESTIONNAIRES_RECEIVED: {
    1: 'questionnaires-received-step-1',
    2: 'questionnaires-received-step-2',
  },
  PRE_AVALIATION: {
    DEFAULT: {
      1: 'pre-avaliations-step-1',
      2: 'pre-avaliations-step-2',
      3: 'pre-avaliations-step-3',
      4: 'pre-avaliations-step-4',
    },
    CREATION: {
      GENERAL_INFO: {
        1: 'pre-avaliation-creation-general-info-step-1',
      },
      EVALUATION: {
        1: 'pre-avaliation-creation-evaluation-step-1',
        2: 'pre-avaliation-creation-evaluation-step-2',
        3: 'pre-avaliation-creation-evaluation-step-3',
        4: 'pre-avaliation-creation-evaluation-step-4',
      },
      AUDIT: {
        1: 'pre-avaliation-creation-audit-step-1',
        2: 'pre-avaliation-creation-audit-step-2',
      },
      RISKS: {
        1: 'pre-avaliation-creation-risks-step-1',
        2: 'pre-avaliation-creation-risks-step-2',
        3: 'pre-avaliation-creation-risks-step-3',
      },
      IMPORT: {
        1: 'pre-avaliation-creation-import-step-1',
        2: 'pre-avaliation-creation-import-step-2',
        3: 'pre-avaliation-creation-import-step-3',
      },
    },
    SHOW: {
      OVERVIEW: {
        1: 'pre-avaliation-show-overview-step-1',
        2: 'pre-avaliation-show-overview-step-2',
        3: 'pre-avaliation-show-overview-step-3',
        4: 'pre-avaliation-show-overview-step-4',
      },
      EVALUATION: {
        1: 'pre-avaliation-show-evaluation-step-1',
        2: 'pre-avaliation-show-evaluation-step-2',
        3: 'pre-avaliation-show-evaluation-step-3',
      },
      AUDIT: {
        1: 'pre-avaliation-show-audit-step-1',
        2: 'pre-avaliation-show-audit-step-2',
      },
    },
    EDIT: {
      RISKS: {
        1: 'pre-avaliation-edit-risks-step-1',
        2: 'pre-avaliation-edit-risks-step-2',
        3: 'pre-avaliation-edit-risks-step-3',
        4: 'pre-avaliation-edit-risks-step-4',
      },
    },
  },
  CREATION: {
    GENERAL_INFO: {
      1: 'creation-general-info-step-1',
    },
    EVALUATION: {
      1: 'creation-evaluation-step-1',
      2: 'creation-evaluation-step-2',
      3: 'creation-evaluation-step-3',
      4: 'creation-evaluation-step-4',
    },
    AUDIT: {
      1: 'creation-audit-step-1',
      2: 'creation-audit-step-2',
    },
    CONTRACT: {
      1: 'creation-contract-step-1',
      2: 'creation-contract-step-2',
    },
    RISKS: {
      1: 'creation-risks-step-1',
      2: 'creation-risks-step-2',
      3: 'creation-risks-step-3',
    },
    IMPORT: {
      1: 'creation-import-step-1',
      2: 'creation-import-step-2',
      3: 'creation-import-step-3',
    },
  },
  SHOW: {
    OVERVIEW: {
      1: 'show-overview-step-1',
      2: 'show-overview-step-2',
      3: 'show-overview-step-3',
      4: 'show-overview-step-4',
    },
    EVALUATION: {
      1: 'show-evaluation-step-1',
      2: 'show-evaluation-step-2',
      3: 'show-evaluation-step-3',
    },
    AUDIT: {
      1: 'show-audit-step-1',
      2: 'show-audit-step-2',
    },
  },
  EDIT: {
    RISKS: {
      1: 'edit-risks-step-1',
      2: 'edit-risks-step-2',
      3: 'edit-risks-step-3',
      4: 'edit-risks-step-4',
    },
  },
}

const STEPS_OBJECT = {
  MY_SUPPLIERS: [
    {
      element: '#' + STEPS.MY_SUPPLIERS[1],
      popover: {
        description:
          'Fornecedores são empresas ou prestadores de serviços que tratam dados pessoais em nome da sua organização. Nesta seção você gerencia o envio de questionários de conformidade, acompanha as respostas e monitora o nível de aderência de cada um deles à LGPD.',
      },
    },
    {
      element: '#' + STEPS.MY_SUPPLIERS[2],
      popover: {
        description:
          'Clique em "Criar" para cadastrar um novo fornecedor. Você poderá informar razão social, documento, e-mail de contato e enviar automaticamente um questionário de conformidade para que o fornecedor responda.',
      },
    },
    {
      element: '#' + STEPS.MY_SUPPLIERS[3],
      popover: {
        description:
          'Cada card mostra a quantidade de fornecedores em um determinado status. Clique em um card para filtrar a listagem automaticamente por aquele status. Por exemplo, clique em "Atrasado" para ver apenas os fornecedores que não responderam dentro do prazo.',
      },
    },
    {
      element: '#' + STEPS.MY_SUPPLIERS[4],
      popover: {
        description:
          'Use as abas "Todos", "Ativos" e "Inativos" para segmentar os fornecedores por situação de vínculo. A barra de pesquisa ao lado permite localizar um fornecedor pelo nome ou documento, basta digitar e apertar "Enter".',
      },
    },
  ],
  SUGGESTIONS: [
    {
      element: '#' + STEPS.SUGGESTIONS[1],
      popover: {
        description:
          'Em "Sugestões" encontram-se fornecedores mencionados no mapeamento de processos que não foram localizados em "Meus Fornecedores".',
      },
    },
    {
      element: '#' + STEPS.SUGGESTIONS[2],
      popover: {
        description:
          'Nas ações, é possível aceitar ou recusar cada sugestão. Ao aceitar a sugestão, o fornecedor será direcionado a tela de Meus Fornecedores.',
      },
    },
  ],
  QUESTIONNAIRES_RECEIVED: [
    {
      element: '#' + STEPS.QUESTIONNAIRES_RECEIVED[1],
      popover: {
        description:
          'Aqui são exibidos os questionários que sua organização precisa responder, solicitados por outras empresas que desejam avaliar a sua conformidade.',
      },
    },
    {
      element: '#' + STEPS.QUESTIONNAIRES_RECEIVED[2],
      popover: {
        description:
          'Nas ações, é possível acessar o portal para responder os questionários recebidos.',
      },
    },
  ],
  PRE_AVALIATION: {
    DEFAULT: [
      {
        element: '#' + STEPS.PRE_AVALIATION.DEFAULT[1],
        popover: {
          description:
            'A Pré-Avaliação é a etapa inicial de triagem de fornecedores. Antes de vincular formalmente um fornecedor à sua organização, você envia um questionário simplificado para avaliar o nível básico de maturidade em privacidade e adequação à LGPD.',
        },
      },
      {
        element: '#' + STEPS.PRE_AVALIATION.DEFAULT[2],
        popover: {
          description:
            'Clique em "Criar" para iniciar uma pré-avaliação. Informe os dados do pré-avaliado e o sistema enviará o acesso ao portal por e-mail.',
        },
        tag: permissions.COMPANY_SUPPLIERS.UPDATE,
      },
      {
        element: '#' + STEPS.PRE_AVALIATION.DEFAULT[3],
        popover: {
          description:
            'Cada card exibe a quantidade de pré-avaliados em um status específico: Aguardando Resposta, Parcialmente Respondido, Atrasado e Respondido. Clique em qualquer card para filtrar a listagem por aquele status e focar nas pendências mais críticas.',
        },
      },
      {
        element: '#' + STEPS.PRE_AVALIATION.DEFAULT[4],
        popover: {
          description:
            'Use as abas "Todos", "Ativos" e "Inativos" para segmentar por situação de vínculo. A barra de pesquisa localiza pré-avaliados pelo nome ou documento, basta digitar e apertar "Enter".',
        },
      },
    ],
    CREATION: {
      GENERAL_INFO: [
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.GENERAL_INFO[1],
          popover: {
            description:
              'Contém os dados cadastrais do pré-avaliado: Razão Social, Documento, Segmento e Descrição. Ative "Documento Internacional" se o pré-avaliado for estrangeiro e não possuir CPF/CNPJ.',
          },
        },
      ],
      EVALUATION: [
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.EVALUATION[1],
          popover: {
            description:
              'Visualize todas as auditorias realizadas com este pré avaliado. Cada card exibe o nome da auditoria, seu status atual e o período de vigência. Clique no menu ⋮ para editar ou excluir uma auditoria existente.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.EVALUATION[2],
          popover: {
            description:
              'Clique em "Nova Auditoria" para iniciar um novo ciclo de avaliação com este pré avaliado. Você poderá definir o período, selecionar os questionários que deseja aplicar e notificar os responsáveis automaticamente.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.EVALUATION[3],
          popover: {
            description:
              'Indica em qual etapa a auditoria se encontra. Os status possíveis são: Aguardando Resposta, Parcialmente Respondido, Atrasado e Respondido. Clique no card da auditoria para acompanhar o progresso de cada questionário.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.EVALUATION[4],
          popover: {
            description:
              'Lista os questionários vinculados à auditoria. Cada item representa um conjunto de questões que o pré avaliado deverá responder dentro do prazo estabelecido.',
          },
        },
      ],
      RISKS: [
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.RISKS[1],
          popover: {
            description:
              'Defina o nível de risco deste pré avaliado utilizando o seletor disponível. O nível deve refletir a criticidade do pré avaliado com base no volume e na sensibilidade dos dados compartilhados com ele.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.RISKS[2],
          popover: {
            description:
              'Adicione as ameaças associadas a este pré avaliado. Você pode criar novas ameaças diretamente nesta tela e gerenciá-las posteriormente pelo menu Diagnóstico > Ameaças.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.RISKS[3],
          popover: {
            description:
              'Registre observações sobre o nível de risco atribuído a este pré avaliado. Utilize este campo para justificar a classificação escolhida, como o tipo e a quantidade de ameaças identificadas, e qualquer informação relevante sobre o relacionamento com este pré avaliado.',
          },
        },
      ],
      IMPORT: [
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.IMPORT[1],
          popover: {
            description:
              'Aqui você pode importar novos pré-avaliados e enviar questionários de triagem para verificar a conformidade antes de formalizar qualquer vínculo.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.IMPORT[2],
          popover: {
            description:
              'As informações obrigatórias são os dados essenciais para o cadastro de um novo pré-avaliado. É possível realizar um cadastro simplificado ou, caso necessário, cadastrar um pré-avaliado internacional. Não se esqueça de utilizar a nossa planilha modelo, a fim de garantir que todos os dados sejam inseridos corretamente.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.IMPORT[3],
          popover: {
            description:
              'Selecione os questionários que os pré-avaliados devem receber.',
          },
        },
      ],
      AUDIT: [
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.AUDIT[1],
          popover: {
            description:
              'Define quem do pré-avaliado receberá o link de acesso ao portal por e-mail, quando será notificado e o prazo limite para resposta. Adicione os e-mails dos responsáveis do pré-avaliado aqui.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.CREATION.AUDIT[2],
          popover: {
            description:
              'Escolha quais questionários serão enviados ao pré-avaliado. Cada um aborda um tema diferente, e reúne as questões necessárias para avaliar o nível básico de maturidade em privacidade.',
          },
        },
      ],
    },
    SHOW: {
      OVERVIEW: [
        {
          element: '#' + STEPS.PRE_AVALIATION.SHOW.OVERVIEW[1],
          popover: {
            description:
              'Indica o percentual de questionários já respondidos pelo pré-avaliado em relação ao total enviado. Quanto mais próximo de 100%, mais completa está a avaliação.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.SHOW.OVERVIEW[2],
          popover: {
            description:
              'Representa o nível de aderência do pré-avaliado às boas práticas de privacidade, calculado com base nas respostas recebidas. Um percentual baixo indica pontos que precisam de atenção.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.SHOW.OVERVIEW[3],
          popover: {
            description:
              'Lista todos os questionários com a quantidade de respostas recebidas. O número em destaque indica o total de questões respondidas.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.SHOW.OVERVIEW[4],
          popover: {
            description:
              'Mostra o progresso de envio de documentos comprobatórios por questionário. A barra preenchida representa a proporção de evidências já recebidas em relação ao total esperado.',
          },
        },
      ],
      EVALUATION: [
        {
          element: '#' + STEPS.PRE_AVALIATION.SHOW.EVALUATION[1],
          popover: {
            description:
              'Visualize todas as auditorias realizadas com este pré avaliado. Cada card exibe o nome da auditoria, seu status atual e o período de vigência. Clique no menu ⋮ para visualizar os detalhes de uma auditoria.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.SHOW.EVALUATION[2],
          popover: {
            description:
              'Indica em qual etapa a auditoria se encontra. Os status possíveis são: Aguardando Resposta, Parcialmente Respondido, Atrasado e Respondido. Clique no card da auditoria para acompanhar o progresso de cada questionário.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.SHOW.EVALUATION[3],
          popover: {
            description:
              'Lista os questionários vinculados à auditoria. Cada item representa um conjunto de questões que o pré avaliado deverá responder dentro do prazo estabelecido.',
          },
        },
      ],
      AUDIT: [
        {
          element: '#' + STEPS.PRE_AVALIATION.SHOW.AUDIT[1],
          popover: {
            description:
              'Define quem do pré-avaliado receberá o link de acesso ao portal por e-mail, quando será notificado e o prazo limite para resposta. Adicione os e-mails dos responsáveis do pré-avaliado aqui.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.SHOW.AUDIT[2],
          popover: {
            description:
              'Cada aba representa um conjunto de questões de um tema. Clique nas abas para navegar entre os temas e ver as respostas enviadas pelo pré-avaliado.',
          },
        },
      ],
    },
    EDIT: {
      RISKS: [
        {
          element: '#' + STEPS.PRE_AVALIATION.EDIT.RISKS[1],
          popover: {
            description:
              'Defina o nível de risco deste pré avaliado utilizando o seletor disponível. O nível deve refletir a criticidade do pré avaliado com base no volume e na sensibilidade dos dados compartilhados com ele.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.EDIT.RISKS[2],
          popover: {
            description:
              'Adicione as ameaças associadas a este pré avaliado. Você pode criar novas ameaças diretamente nesta tela e gerenciá-las posteriormente pelo menu Diagnóstico > Ameaças.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.EDIT.RISKS[3],
          popover: {
            description:
              'Registre observações sobre o nível de risco atribuído a este pré avaliado. Utilize este campo para justificar a classificação escolhida, como o tipo e a quantidade de ameaças identificadas, e qualquer informação relevante sobre o relacionamento com este pré avaliado.',
          },
        },
        {
          element: '#' + STEPS.PRE_AVALIATION.EDIT.RISKS[4],
          popover: {
            description:
              'Com base no questionário já respondido (pelo pré avaliado na etapa de Avaliações), defina os planos de ação para este pré avaliado. Os planos podem ser voltados para ações que o próprio pré avaliado deve executar ou para medidas internas que sua organização precisa adotar em relação a ele. Na visualização do pré avaliado, também é possível enviar planos de ação diretamente para ele.',
          },
        },
      ],
    },
  },
  CREATION: {
    GENERAL_INFO: [
      {
        element: '#' + STEPS.CREATION.GENERAL_INFO[1],
        popover: {
          description:
            'Contém os dados cadastrais do fornecedor: Razão Social, Documento, Segmento e Descrição. Ative "Documento Internacional" se o fornecedor for estrangeiro e não possuir CPF/CNPJ.',
        },
      },
    ],
    EVALUATION: [
      {
        element: '#' + STEPS.CREATION.EVALUATION[1],
        popover: {
          description:
            'Visualize todas as auditorias realizadas com este fornecedor. Cada card exibe o nome da auditoria, seu status atual e o período de vigência. Clique no menu ⋮ para editar ou excluir uma auditoria existente.',
        },
      },
      {
        element: '#' + STEPS.CREATION.EVALUATION[2],
        popover: {
          description:
            'Clique em "Nova Auditoria" para iniciar um novo ciclo de avaliação com este fornecedor. Você poderá definir o período, selecionar os questionários que deseja aplicar e notificar os responsáveis automaticamente.',
        },
      },
      {
        element: '#' + STEPS.CREATION.EVALUATION[3],
        popover: {
          description:
            'Indica em qual etapa a auditoria se encontra. Os status possíveis são: Aguardando Resposta, Parcialmente Respondido, Atrasado e Respondido. Clique no card da auditoria para acompanhar o progresso de cada questionário.',
        },
      },
      {
        element: '#' + STEPS.CREATION.EVALUATION[4],
        popover: {
          description:
            'Lista os questionários vinculados à auditoria. Cada item representa um conjunto de questões que o fornecedor deverá responder dentro do prazo estabelecido.',
        },
      },
    ],
    CONTRACT: [
      {
        element: '#' + STEPS.CREATION.CONTRACT[1],
        popover: {
          description:
            'Registre datas de contratação e renovação, e defina os papéis de cada parte conforme a LGPD: Controlador, Operador, Suboperador ou Co-controlador. Ative a opção de transferência internacional se dados forem enviados ao exterior.',
        },
      },
      {
        element: '#' + STEPS.CREATION.CONTRACT[2],
        popover: {
          description:
            'Área para upload dos documentos relacionados ao contrato (DPA, NDA, políticas etc.). Os arquivos ficam vinculados ao fornecedor e podem ser consultados a qualquer momento.',
        },
      },
    ],
    RISKS: [
      {
        element: '#' + STEPS.CREATION.RISKS[1],
        popover: {
          description:
            'Defina o nível de risco deste fornecedor utilizando o seletor disponível. O nível deve refletir a criticidade do fornecedor com base no volume e na sensibilidade dos dados compartilhados com ele.',
        },
      },
      {
        element: '#' + STEPS.CREATION.RISKS[2],
        popover: {
          description:
            'Adicione as ameaças associadas a este fornecedor. Você pode criar novas ameaças diretamente nesta tela e gerenciá-las posteriormente pelo menu Diagnóstico > Ameaças.',
        },
      },
      {
        element: '#' + STEPS.CREATION.RISKS[3],
        popover: {
          description:
            'Registre observações sobre o nível de risco atribuído a este fornecedor. Utilize este campo para justificar a classificação escolhida, como o tipo e a quantidade de ameaças identificadas, e qualquer informação relevante sobre o relacionamento com este fornecedor.',
        },
      },
    ],
    IMPORT: [
      {
        element: '#' + STEPS.CREATION.IMPORT[1],
        popover: {
          description: 'Aqui você pode importar novos fornecedores.',
        },
      },
      {
        element: '#' + STEPS.CREATION.IMPORT[2],
        popover: {
          description:
            'As informações obrigatórias são os dados essenciais para o cadastro de um novo fornecedor. É possível realizar um cadastro simplificado ou, caso seja necessário, cadastrar um fornecedor internacional. Não se esqueça de utilizar a nossa planilha modelo, a fim de garantir que todos os dados sejam inseridos corretamente.',
        },
      },
      {
        element: '#' + STEPS.CREATION.IMPORT[3],
        popover: {
          description:
            'Selecione os questionários que os fornecedores devem receber.',
        },
      },
    ],
    AUDIT: [
      {
        element: '#' + STEPS.CREATION.AUDIT[1],
        popover: {
          description:
            'Define quem do fornecedor receberá o link de acesso ao portal por e-mail, quando será notificado e o prazo limite para resposta. Adicione os e-mails dos responsáveis do fornecedor aqui.',
        },
      },
      {
        element: '#' + STEPS.CREATION.AUDIT[2],
        popover: {
          description:
            'Escolha quais questionários serão enviados ao fornecedor. Cada um aborda um tema diferente, e reúne as questões necessárias para avaliar a conformidade do fornecedor naquele contexto.',
        },
      },
    ],
  },
  SHOW: {
    OVERVIEW: [
      {
        element: '#' + STEPS.SHOW.OVERVIEW[1],
        popover: {
          description:
            'Indica o percentual de questionários já respondidos pelo fornecedor em relação ao total enviado. Quanto mais próximo de 100%, mais completa está a avaliação.',
        },
      },
      {
        element: '#' + STEPS.SHOW.OVERVIEW[2],
        popover: {
          description:
            'Representa o nível de aderência do fornecedor às boas práticas de privacidade, calculado com base nas respostas recebidas. Um percentual baixo indica pontos que precisam de atenção.',
        },
      },
      {
        element: '#' + STEPS.SHOW.OVERVIEW[3],
        popover: {
          description:
            'Lista todos os questionários com a quantidade de respostas recebidas. O número em destaque indica o total de questões respondidas.',
        },
      },
      {
        element: '#' + STEPS.SHOW.OVERVIEW[4],
        popover: {
          description:
            'Mostra o progresso de envio de documentos comprobatórios por questionário. A barra preenchida representa a proporção de evidências já recebidas em relação ao total esperado.',
        },
      },
    ],
    EVALUATION: [
      {
        element: '#' + STEPS.SHOW.EVALUATION[1],
        popover: {
          description:
            'Visualize todas as auditorias realizadas com este fornecedor. Cada card exibe o nome da auditoria, seu status atual e o período de vigência. Clique no menu ⋮ para visualizar os detalhes de uma auditoria.',
        },
      },
      {
        element: '#' + STEPS.SHOW.EVALUATION[2],
        popover: {
          description:
            'Indica em qual etapa a auditoria se encontra. Os status possíveis são: Aguardando Resposta, Parcialmente Respondido, Atrasado e Respondido. Clique no card da auditoria para acompanhar o progresso de cada questionário.',
        },
      },
      {
        element: '#' + STEPS.SHOW.EVALUATION[3],
        popover: {
          description:
            'Lista os questionários vinculados à auditoria. Cada item representa um conjunto de questões que o fornecedor deverá responder dentro do prazo estabelecido.',
        },
      },
    ],
    AUDIT: [
      {
        element: '#' + STEPS.SHOW.AUDIT[1],
        popover: {
          description:
            'Define quem do fornecedor receberá o link de acesso ao portal por e-mail, quando será notificado e o prazo limite para resposta. Adicione os e-mails dos responsáveis do fornecedor aqui.',
        },
      },
      {
        element: '#' + STEPS.SHOW.AUDIT[2],
        popover: {
          description:
            'Cada aba representa um conjunto de questões de um tema. Clique nas abas para navegar entre os temas e ver as respostas enviadas pelo fornecedor.',
        },
      },
    ],
  },
  EDIT: {
    RISKS: [
      {
        element: '#' + STEPS.EDIT.RISKS[1],
        popover: {
          description:
            'Defina o nível de risco deste fornecedor utilizando o seletor disponível. O nível deve refletir a criticidade do fornecedor com base no volume e na sensibilidade dos dados compartilhados com ele.',
        },
      },
      {
        element: '#' + STEPS.EDIT.RISKS[2],
        popover: {
          description:
            'Adicione as ameaças associadas a este fornecedor. Você pode criar novas ameaças diretamente nesta tela e gerenciá-las posteriormente pelo menu Diagnóstico > Ameaças.',
        },
      },
      {
        element: '#' + STEPS.EDIT.RISKS[3],
        popover: {
          description:
            'Registre observações sobre o nível de risco atribuído a este fornecedor. Utilize este campo para justificar a classificação escolhida, como o tipo e a quantidade de ameaças identificadas, e qualquer informação relevante sobre o relacionamento com este fornecedor.',
        },
      },
      {
        element: '#' + STEPS.EDIT.RISKS[4],
        popover: {
          description:
            'Com base no questionário já respondido (pelo fornecedor na etapa de Avaliações), defina os planos de ação para este fornecedor. Os planos podem ser voltados para ações que o próprio fornecedor deve executar ou para medidas internas que sua organização precisa adotar em relação a ele. Na visualização do fornecedor, também é possível enviar planos de ação diretamente para ele.',
        },
      },
    ],
  },
}

export default {
  STEPS,
  STEPS_OBJECT,
}
